import { Stack, Text, Title } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { useAuth } from "../../hooks/useAuth";
import { OverallPerformanceDateRangePicker } from "./OverallPerformanceDateRangePicker";
import { OverallPerformanceCharts } from "./OverallPerformanceCharts";
import { COMPANY_NAME } from "../../constants";

export const OverallPerformance = () => {
  const i18n = useI18n();
  const { isAirlineUser } = useAuth();

  return (
    <Stack gap={6}>
      <Stack direction="column" gap={2}>
        <Title title={i18n.trans(t("flights_airline_portal_airline_view_page_header_two"))} variant="headline_2" />
        <Text variant="body_2">
          {isAirlineUser
            ? i18n.trans(t("flights_airline_portal_airline_view_page_subheader_two"))
            : i18n.trans(
                t("flights_airline_portal_superuser_perf_report_realtime_subheader", {
                  variables: { b_companyname: COMPANY_NAME },
                })
              )}
        </Text>
      </Stack>
      <Stack gap={1}>
        <Text variant="emphasized_2">{i18n.trans(t("flights_airline_portal_campaign_date_picker_label"))}</Text>
        <OverallPerformanceDateRangePicker />
      </Stack>
      <OverallPerformanceCharts />
    </Stack>
  );
};
